import React from "react";
import { ReactController } from "../react_controller";
import { DataTagModal, GregPrimerTheme } from "@getregistered/greg-editors";
import { Button } from "@primer/react";

const MetadataModalContainer = ({ onSave, metadata: initialMeta }) => {
  const [metadata, setMetadata] = React.useState(initialMeta || []);
  const [isOpen, setIsOpen] = React.useState(false);

  const handleSave = (newMetadata) => {
    setMetadata(newMetadata);
    onSave(newMetadata);
    setIsOpen(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const hasMetadata = metadata && metadata.length > 0;
  const buttonText = hasMetadata ? "Manage Data Tags" : "Add Data Tags";

  return (
    <GregPrimerTheme>
      <Button onClick={handleOpen} variant={hasMetadata ? "default" : "invisible"}>
        {buttonText}
      </Button>
      <DataTagModal
        isOpen={isOpen}
        onClose={handleClose}
        metadata={metadata}
        onSave={handleSave}
      />
    </GregPrimerTheme>
  );
};

export class MetadataModalController extends ReactController {
  connect() {
    this.form = this.element.closest("form");
    const { name, metadata } = this.propsValue;
    this.metadata = metadata || [];

    this.form.addEventListener("formdata", (event) => {
      const formData = event.formData;
      this.metadata.forEach(({ key, value }) => {
        formData.append(`${name}[][key]`, key);
        formData.append(`${name}[][value]`, value);
      });
    });

    this.root.render(
      <MetadataModalContainer
        metadata={this.metadata}
        onSave={(metadata) => {
          this.metadata = metadata;
        }}
      />
    );
  }
}
